module.exports = __webpack_public_path__ + "img/342.74c1159f.png";